// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/mvd/mondoo_mvd.actions.go

export const ANALYSE_ASSET = "mondoo.vuln.AdvisoryScanner.AnalyseAsset";
